import React from "react";

function BackMenuItemBubble({messageText, onClick}) {
  return (
    <div>
      <div className="menuItemBubble" onClick={onClick}>
         {messageText}
      </div>
    </div>
  );
}

export default BackMenuItemBubble;
